import { useCompanyDirectorsQuery } from '../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Trans } from '@lingui/react';
import { Box } from '@startuptools/ui/Box';
import { Card } from '@startuptools/ui/Card';
import { CardContent } from '@startuptools/ui/CardContent';
import { Stack } from '@startuptools/ui/Stack';
import { Table } from '@startuptools/ui/Table';
import { Typography } from '@startuptools/ui/Typography';
import { orderBy, startCase } from 'lodash-es';
import { allBoardMembers } from '../../common/types';
import { Identity } from '@startuptools/business-ui/identity/Identity';

export const CompanyDirectors = () => {
  const companyId = useCompanyId();
  const { data, loading } = useCompanyDirectorsQuery({ variables: { companyId } });

  if (loading) {
    return null;
  }

  const cds = orderBy(data?.companyDirectors, cd => cd?.identity?.name, 'asc');

  if (cds.length === 0) {
    return (
      <Box p={2}>
        <Typography level="h2">
          <Trans id="Company directors" />
        </Typography>
        <CardContent>
          <Trans id="The company has no board of directors registered" />
        </CardContent>
      </Box>
    );
  }

  const boardMembers = cds.filter(cd => cd.functions.some(f => allBoardMembers.includes(f.code)));
  const others = cds.filter(cd => !cd.functions.some(f => allBoardMembers.includes(f.code)));

  return (
    <Stack gap={2}>
      <Typography level="h2">
        <Trans id="Company directors" />
      </Typography>

      <Card>
        <Table>
          <tbody>
            {boardMembers.map(bm => (
              <tr key={bm.id}>
                <td>{bm.identity && <Identity identity={bm.identity} />}</td>
                <td>{bm.functions.map(f => startCase(f.kind.toLowerCase())).join(', ')}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
      {others.length > 0 && (
        <>
          <Typography level="title-lg" py={2}>
            <Trans id="Others" />
          </Typography>
          <Card>
            <Table>
              <tbody>
                {others.map(bm => (
                  <tr key={bm.id}>
                    <td>{bm.identity && <Identity identity={bm.identity} />}</td>
                    <td>{bm.functions.map(f => startCase(f.kind.toLowerCase())).join(', ')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </>
      )}
    </Stack>
  );
};
